import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Waves, Phone } from "lucide-react";
import { CONTACT } from "@/assets";

const links = [
    { label: "Services", href: "#services", id: "nav-link-services" },
    { label: "Our Work", href: "#gallery", id: "nav-link-gallery" },
    { label: "Contact", href: "#contact", id: "nav-link-contact" },
];

const Nav = () => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <motion.header
            data-testid="site-nav"
            initial={{ y: -80, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
            className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
                scrolled
                    ? "backdrop-blur-2xl bg-[#03070A]/70 border-b border-white/10"
                    : "bg-transparent border-b border-transparent"
            }`}
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-[72px] flex items-center justify-between">
                <a href="#top" data-testid="nav-logo" className="flex items-center gap-2 group">
                    <Waves className="w-5 h-5 text-[#00E5FF] transition-transform duration-500 group-hover:rotate-12" />
                    <span className="font-display text-lg tracking-tight text-[#F4F4F0]">
                        TJE Pool Maintenance
                    </span>
                </a>
                <nav className="hidden md:flex items-center gap-10">
                    {links.map((l) => (
                        <a
                            key={l.id}
                            href={l.href}
                            data-testid={l.id}
                            className="text-xs uppercase tracking-[0.2em] text-[#8A949E] hover:text-[#F4F4F0] transition-colors duration-300"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>
                <a
                    href={CONTACT.phoneHref}
                    data-testid="nav-call-button"
                    className="flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-xs tracking-wider text-[#F4F4F0] hover:bg-[#00E5FF] hover:text-[#03070A] hover:border-[#00E5FF] transition-colors duration-300"
                >
                    <Phone className="w-3.5 h-3.5" />
                    <span className="hidden sm:inline">{CONTACT.phoneDisplay}</span>
                    <span className="sm:hidden">Call</span>
                </a>
            </div>
        </motion.header>
    );
};

export default Nav;
